// Food Preferences picker — grouped food lists.
// Clients mark each food "Love it" or "Avoid / can't eat"; results save to the
// quiz system and appear in Admin → Quiz Results under the client's email.
// TO EDIT: add/remove strings in any group's `items`. Keep names short.

export const foodGroups = [
  {
    id: 'vegetables',
    name: 'Vegetables',
    note: 'Lemons & limes are accepted here too.',
    items: [
      'Artichoke (common & Jerusalem)', 'Asparagus', 'Bamboo shoots', 'Green & string beans',
      'Broccoli', 'Cauliflower', 'Brussels sprouts', 'Cabbage (red, green, napa)', 'Celery',
      'Onions (all, incl. leeks)', 'Radishes (red & daikon)', 'Kale', 'Collard greens',
      'Mustard greens', 'Turnip greens', 'Dandelion greens', 'Beet greens', 'Bok choy', 'Tatsoi',
      'Chicory', 'Arugula', 'Mixed / mesclun greens', 'Romaine', 'Spinach', 'Leaf lettuce (red & green)',
      'Green peas', 'Sugar snap peas', 'Snow peas', 'Seaweed / dulse', 'Butternut squash',
      'Buttercup squash', 'Acorn squash', 'Pumpkin', 'Spaghetti squash', 'Winter squash', 'Zucchini',
      'Water chestnuts', 'Beets', 'Carrots', 'Cassava', 'Celery root', 'Jicama', 'Rutabaga',
      'Sweet potato', 'Parsnip', 'Turnips', 'Taro', 'Yucca', 'Lemon', 'Lime',
    ],
  },
  {
    id: 'proteins',
    name: 'Proteins',
    items: [
      'Grass-fed beef', 'Bison', 'Lamb', 'Pork', 'Chicken', 'Turkey', 'Duck', 'Eggs',
      'Wild salmon', 'Sardines', 'Mackerel', 'Tuna', 'White fish (cod / haddock)', 'Shrimp',
      'Scallops', 'Mussels', 'Lentils', 'Chickpeas', 'Black beans', 'Kidney beans', 'Tofu', 'Tempeh',
    ],
  },
  {
    id: 'nuts-seeds-fats',
    name: 'Nuts, Seeds & Healthy Fats',
    items: [
      'Almonds', 'Walnuts', 'Cashews', 'Pecans', 'Pistachios', 'Macadamia nuts', 'Pumpkin seeds',
      'Sunflower seeds', 'Sesame seeds / tahini', 'Chia seeds', 'Flax seeds', 'Hemp seeds',
      'Nut butters', 'Avocado', 'Olives', 'Olive oil', 'Coconut / coconut oil', 'Avocado oil',
      'Butter / ghee', 'Tallow / duck fat',
    ],
  },
  {
    id: 'grains-starches-dairy',
    name: 'Grains, Starches & Dairy',
    items: [
      'White rice', 'Brown rice', 'Quinoa', 'Oats', 'Buckwheat', 'Millet', 'Gluten-free pasta',
      'Sourdough bread', 'Potatoes', 'Plantain', "Cow's milk", 'Goat milk / cheese', 'Hard cheese',
      'Yogurt / kefir', 'Cottage cheese', 'Almond milk', 'Coconut milk', 'Oat milk',
    ],
  },
];
